// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"UnifiedPromptBlocksInfoModal_modalWrapper__1CiC0","likeAnimation":"UnifiedPromptBlocksInfoModal_likeAnimation__3rOOs"};